import { render, staticRenderFns } from "./Pcua.vue?vue&type=template&id=5cbc398f&"
import script from "./Pcua.vue?vue&type=script&lang=js&"
export * from "./Pcua.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports